var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04175 3.20825H2.41675C2.08523 3.20825 1.76728 3.33995 1.53286 3.57437C1.29844 3.80879 1.16675 4.12673 1.16675 4.45825V10.0833C1.16675 10.4148 1.29844 10.7327 1.53286 10.9671C1.76728 11.2016 2.08523 11.3333 2.41675 11.3333H8.04175C8.37327 11.3333 8.69121 11.2016 8.92563 10.9671C9.16005 10.7327 9.29175 10.4148 9.29175 10.0833V9.45825",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 1.95832L10.5417 3.83332M11.4074 2.94894C11.6535 2.70279 11.7918 2.36893 11.7918 2.02082C11.7918 1.6727 11.6535 1.33885 11.4074 1.09269C11.1612 0.84654 10.8274 0.708252 10.4792 0.708252C10.1311 0.708252 9.79728 0.84654 9.55112 1.09269L4.29175 6.33332V8.20832H6.16675L11.4074 2.94894Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.176260fd5f46327c9a0fe2497b763cb4.svg";
export { ForwardRef as ReactComponent };